import EventStandings from "./EventStandings";
export default EventStandings;
